module.exports = __webpack_public_path__ + "static/media/Daniel_Voskoboynik_S21.1b006fe4.png";